export default "__VITE_ASSET__BaJZ8QNR__"